import PropTypes from 'prop-types';

export const travelAgency = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
};

export const tourType = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
  travel_agency: PropTypes.number.isRequired,
};
export const noteType = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  created_on: PropTypes.string,
};
export const hotelType = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
export const bidType = {
  id: PropTypes.number.isRequired,
  hotel: PropTypes.shape(hotelType).isRequired,
  start: PropTypes.string,
  end: PropTypes.string,
  suites: PropTypes.number,
  kings: PropTypes.number,
  queens: PropTypes.number,
  suite_rate: PropTypes.number,
  kings_rate: PropTypes.number,
  queens_rate: PropTypes.number,
  notes: PropTypes.arrayOf(PropTypes.shape(noteType)),
};

export const bookingRequest = {
  id: PropTypes.number.isRequired,
  tour: PropTypes.shape(tourType).isRequired,
  bids: PropTypes.arrayOf(PropTypes.shape(bidType)),
};



// WEBPACK FOOTER //
// src/routes/tours/components/CatchPropTypes.js